// Autogenerated by `yarn version-file`. DO NOT EDIT
export const VERSION = '1.10.0';
